// MISC_NUMBERS
//
//
//
//
//
//
export function initNumbers() {

    
    ///////////////////////////////////////////////
    // NUMBER ANIMATIONS (GSAP)
    ////////////////////////////////////////////////

    // Check if there are any number elements
    if (document.querySelectorAll('.text-numbers').length > 0) {
        // Get all number elements
        const numberElements = document.querySelectorAll('.text-numbers');
        const numberBoxes = document.querySelectorAll('.numbers-box');
        
        // Reset initial state
        gsap.set(numberBoxes, { opacity: 0, y: 20 });
        numberElements.forEach(element => {
            const fullText = element.getAttribute('data-target');
            // Extract just the numeric part for animation
            const numericPart = fullText.match(/\d+/)?.[0] || '0';
            element.textContent = numericPart;
        });

        // Create ScrollTrigger for the container
        ScrollTrigger.create({
            trigger: '.numbers-boxes',
            start: "top 80%",
            end: "bottom 20%",
            onEnter: () => {
                // Create a new timeline for each scroll in
                const masterTl = gsap.timeline();
                
                // Fade in boxes
                masterTl.to(numberBoxes, {
                    opacity: 1,
                    y: 0,
                    duration: 0.3,
                    stagger: 0.1,
                    ease: "power2.out"
                });

                // Animate numbers
                numberElements.forEach((element, index) => {
                    const fullText = element.getAttribute('data-target');
                    // Extract just the numeric part for animation
                    const numericPart = fullText.match(/\d+/)?.[0] || '0';
                    const finalValue = parseInt(numericPart);
                    
                    masterTl.to(element, {
                        duration: 0.3,
                        textContent: finalValue,
                        snap: { textContent: 1 },
                        ease: "power4.out",
                        onUpdate: function() {
                            const progress = this.progress();
                            const randomRange = Math.max(1, Math.floor(finalValue * progress));
                            const currentValue = Math.floor(finalValue * progress + (Math.random() * randomRange));
                            // Replace only the numeric part in the full text
                            element.textContent = fullText.replace(/\d+/, currentValue);
                        },
                        onComplete: function() {
                            // Restore the full text with all characters
                            element.textContent = fullText;
                        }
                    }, index * 0.1); // Reduced stagger timing
                });
            },
            onLeaveBack: () => {
                // Reset state when scrolling back out
                gsap.to(numberBoxes, {
                    opacity: 0,
                    y: 20,
                    duration: 0.3,
                    stagger: 0.1,
                    ease: "power2.in",
                    onComplete: () => {
                        numberElements.forEach(element => {
                            const fullText = element.getAttribute('data-target');
                            // Extract just the numeric part for reset
                            const numericPart = fullText.match(/\d+/)?.[0] || '0';
                            element.textContent = fullText.replace(/\d+/, '0');
                        });
                    }
                });
            }
        });
    }

    // END OF MODULE
    console.log("Numbers-Module initialized");

}